import type { ReactNode } from "react";

import type { QueryPeriod } from "../types.js";

export function LoadingState({ label = "ЗАГРУЗКА ДАННЫХ" }: { label?: string }) {
  return (
    <div className="state-panel">
      <span className="activity-mark" />
      <span>{label}</span>
    </div>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <div className="state-panel state-panel--empty">
      <span className="state-code">∅</span>
      <span>{children}</span>
    </div>
  );
}

export function ErrorState({
  message,
  onRetry
}: {
  message: string;
  onRetry(): void;
}) {
  return (
    <div className="state-panel state-panel--error">
      <span className="state-code">ERR</span>
      <span>{message}</span>
      <button className="button button--quiet" onClick={onRetry}>
        ПОВТОРИТЬ
      </button>
    </div>
  );
}

export function PeriodSelector({
  value,
  onChange
}: {
  value: QueryPeriod;
  onChange(value: QueryPeriod): void;
}) {
  const selected = value.from ? "custom" : (value.period ?? "24h");
  const activateCustom = (): void => {
    const to = new Date();
    const from = new Date(to.getTime() - 7 * 24 * 60 * 60 * 1_000);
    onChange({
      from: from.toISOString(),
      to: to.toISOString()
    });
  };
  return (
    <div className="period-control">
      {(["24h", "7d", "30d"] as const).map((period) => (
        <button
          key={period}
          className={selected === period ? "is-active" : ""}
          onClick={() => onChange({ period })}
        >
          {period.toUpperCase()}
        </button>
      ))}
      <button
        className={selected === "custom" ? "is-active" : ""}
        onClick={activateCustom}
      >
        ДИАПАЗОН
      </button>
      {selected === "custom" && value.from && value.to ? (
        <div className="date-range">
          <input
            type="datetime-local"
            value={value.from.slice(0, 16)}
            onChange={(event) =>
              onChange({
                from: new Date(event.target.value).toISOString(),
                to: value.to!
              })
            }
          />
          <span>—</span>
          <input
            type="datetime-local"
            value={value.to.slice(0, 16)}
            onChange={(event) =>
              onChange({
                from: value.from!,
                to: new Date(event.target.value).toISOString()
              })
            }
          />
        </div>
      ) : null}
    </div>
  );
}

export function Pagination({
  total,
  limit,
  offset,
  onChange
}: {
  total: number;
  limit: number;
  offset: number;
  onChange(offset: number): void;
}) {
  const start = total === 0 ? 0 : offset + 1;
  const end = Math.min(total, offset + limit);
  return (
    <div className="pagination">
      <span>
        {start}–{end} / {total}
      </span>
      <button
        disabled={offset === 0}
        onClick={() => onChange(Math.max(0, offset - limit))}
      >
        ←
      </button>
      <button
        disabled={offset + limit >= total}
        onClick={() => onChange(offset + limit)}
      >
        →
      </button>
    </div>
  );
}
